(function attachKSHandler(){
  console.log('[KS] Universal play handler attached');
  document.addEventListener('click', e => {
    const btn = e.target.closest('.ks-video-play-button');
    if (!btn) return;
    const placeholder = btn.closest('.ks-video-placeholder');
    const url = placeholder?.dataset.videoUrl;
    if (!url) return console.warn('[KS] No video URL found on placeholder.');

    // create iframe
    const iframe = document.createElement('iframe');
    iframe.src = url + (url.includes('?') ? '&' : '?') + 'autoplay=1&muted=1&playsinline=1&rel=0';
    iframe.width = placeholder.dataset.videoWidth || '100%';
    iframe.height = placeholder.dataset.videoHeight || '100%';
    iframe.allow = 'autoplay; fullscreen';
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';
    iframe.className = 'auto-resizable-iframe';

    // clear and insert
    placeholder.innerHTML = '';
    placeholder.appendChild(iframe);
    console.log('[KS] injected iframe →', iframe.src);
  });
})();
